import React, { useContext } from 'react';
import styled from 'styled-components';

import { Badge } from 'components';
import { TeamContext } from 'contexts';
import { LayoutCard, Loading } from '../components';
import { useTasks } from '../hooks';
import { AllTaskSection } from '../Section/TaskSection';

const TeamTasksCard = () => {
  const { targetTeamId } = useContext(TeamContext);

  const {
    isTasksLoading,
    taskItems,
    totalCount,
    taskSearchValue,
    setTaskSearchValue,
    permissionsMap,
    refetchTasks,
  } = useTasks('team', targetTeamId);

  return (
    <LayoutCard
      search={{
        searchValue: taskSearchValue,
        onSearchValueChange: setTaskSearchValue,
      }}
      title={
        <TasksHeaderContainer>
          Tasks
          <Badge count={totalCount} />
        </TasksHeaderContainer>
      }
      tabList={[{ key: 'all', tab: 'All' }]}
      tabProps={{
        size: 'small',
      }}
      data-cy="dashboard-team-tasks-card"
    >
      {isTasksLoading ? (
        <Loading />
      ) : (
        <AllTaskSection
          items={taskItems}
          permissionsMap={permissionsMap}
          refetchTasks={refetchTasks}
          team
        />
      )}
    </LayoutCard>
  );
};

export default TeamTasksCard;

const TasksHeaderContainer = styled.div`
  display: inline-grid;
  grid-template-columns: 1fr auto;
  align-items: center;
  column-gap: 8px;
`;
